export default __webpack_public_path__ + "static/media/594.d22fb599.gif";